import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import {ReflexiveField} from 'src/lib/reflexive-model/reflexive-field';
import {FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn} from '@angular/forms';
import {ReflexiveRestModel} from 'src/lib/reflexive-model/reflexive-rest-model';
import {FieldType} from 'src/lib/reflexive-model/field-type.enum';
import {BehaviorSubject, Subscription} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import {ImmutableListRepositoryService} from '../immutable-list-repository.service';
import {delay, filter} from 'rxjs/operators';
import {GeliosFieldService} from '../gelios-field.service';
import {conjugationOfDay} from '../../../app/utility/word-declensions';

@Component({
  selector: 'app-gelios-field',
  templateUrl: './gelios-field.component.html',
})
export class GeliosFieldComponent implements OnInit, AfterViewInit, OnDestroy {
  @HostBinding('class.form__base-field') field = true;
  fieldType = FieldType;
  tabSwitchButton = false;
  @ViewChild('tabFormContainerItems')
  tabFormContainerItems: ElementRef;
  @ViewChildren('tab')
  tabs: QueryList<any>;
  @ViewChild('tabFormContainer')
  tabFormContainer: ElementRef;
  @ViewChild('tabFormAddButtonContainer')
  tabFormAddButtonContainer: ElementRef;
  tabVisible: number = null;
  tabAdded: BehaviorSubject<boolean> = new BehaviorSubject(false);
  @Input() model: ReflexiveRestModel;
  @Input() fieldName: string;
  @Input() formGroup: FormGroup;
  @Output() valueChange: EventEmitter<any> = new EventEmitter();
  // @ViewChild('geliosSelectFieldComponent') geliosSelectFieldComponent: GeliosSelectFieldComponent;
  public reflexiveField: ReflexiveField;
  public fieldLabel: string;
  private _isRequired: boolean | null = null;
  // [model]="model"
  // [fieldName]="fieldName"
  // [formGroup]="userFormGroup"

  /* for tariff-plans form start */
  public items: Array<any>;
  public selectedItem: string;

  public subscriptions: Subscription[] = [];

  /* for tariff-plans form end */


  get selectItems(): Array<any> {
    if (this.items) {
      return this.items;
    }
    return this.reflexiveField.selectSettings && this.reflexiveField.selectSettings.items ?
      this.reflexiveField.selectSettings.items : [];
  }

  constructor(
    protected formBuilder: FormBuilder,
    protected translate: TranslateService,
    protected immutableList: ImmutableListRepositoryService,
    protected changeDetector: ChangeDetectorRef,
    public geliosFieldService: GeliosFieldService
  ) {
  }


  ngOnInit() {
    this.reflexiveField = this.model.getField(this.fieldName);
    if (this.reflexiveField && this.reflexiveField.onInit) {
      this.reflexiveField.onInit(this);
    }
    this.fieldLabel = this.model.getLabel(this.fieldName);
    if (this.reflexiveField.type === FieldType.ReflexiveModelArrayField
      && this.formGroup.controls[this.fieldName]['controls'].length > 0) {
      this.tabActive(0);
    }
    this.geliosFieldService.clickedTab
      .pipe(filter(t => t !== null))
      .subscribe(tab => {
      if (tab.fieldNamesSync.find(fieldName => fieldName === this.fieldName)) {
        this.tabVisible = tab.index;
      }
    });
    this.geliosFieldService.switchRightTabs
      .pipe(filter(t => t !== null))
      .subscribe(tabToSwitch => {
        if (tabToSwitch.fieldNamesSync.find(fieldName => fieldName === this.fieldName) && this.tabs !== undefined) {
          let scrollToOffset = 0;
          let tabIsAboutToShowWidth = 0;
          this.tabs.forEach((tab, i) => {
            if (i < tabToSwitch.index) {
              scrollToOffset += tab.nativeElement.offsetWidth;
            }
            if (i === tabToSwitch.index) {
              tabIsAboutToShowWidth = tab.nativeElement.offsetWidth;
            }
          });
          const rightSide = this.tabFormContainerItems.nativeElement.scrollLeft + this.tabFormContainerItems.nativeElement.offsetWidth;
          if ((scrollToOffset + tabIsAboutToShowWidth) > rightSide) {
            this.tabFormContainerItems.nativeElement.scrollLeft = scrollToOffset;
          }
        }
      });
    this.geliosFieldService.switchLeftTabs
      .pipe(filter(t => t !== null))
      .subscribe(tabToSwitch => {
        if (tabToSwitch.fieldNamesSync.find(fieldName => fieldName === this.fieldName) && this.tabs !== undefined) {
          let scrollToOffset = 0;
          this.tabs.forEach((tab, i) => {
            if (i < tabToSwitch.index) {
              scrollToOffset += tab.nativeElement.offsetWidth;
            }
          });
          if (scrollToOffset < this.tabFormContainerItems.nativeElement.scrollLeft) {
            this.tabFormContainerItems.nativeElement.scrollLeft = scrollToOffset;
          }
          this.tabActive(tabToSwitch.index);
        }
    });
    this.geliosFieldService.tabAddedFieldNames
      .pipe(
        filter(f => f !== null),
        delay(0)
      )
      .subscribe(fields => {
        if (fields.find(fieldName => fieldName === this.fieldName)) {
          if (this.tabFormContainerItems) {
            this.tabFormContainerItems.nativeElement.scrollLeft = this.tabFormContainerItems.nativeElement.scrollWidth;
          }
        }
    });
    this.tabAdded
      .pipe(filter(added => added))
      .subscribe(() => {
        let fields = [this.fieldName];
        if (this.hasSyncFields()) {
          fields = fields.concat(this.getSyncFields());
        }
        this.geliosFieldService.tabAddedFieldNames.next(fields);
      });
    if (this.reflexiveField.reflexiveModelArrayConfig && this.reflexiveField.reflexiveModelArrayConfig.tabConfig) {
      if (this.reflexiveField.reflexiveModelArrayConfig.tabConfig.buttonAddHidden) {
      }
    }
  }

  get tabsHeaderLabelIsVisible(): boolean {
    const config = this.reflexiveField
    && this.reflexiveField.reflexiveModelArrayConfig
    && this.reflexiveField.reflexiveModelArrayConfig.tabsHeaderLabelConfig
      ? this.reflexiveField.reflexiveModelArrayConfig.tabsHeaderLabelConfig : null;

    const controls = this.formGroup && this.formGroup.controls;
    const control = controls && controls[this.fieldName];

    const alwaysHide = config && config.alwaysHideLabel === true;
    const hideIfNoTabs = config && config.hideLabelIfNoTabs === true && control && (control as FormArray).length === 0;
    return !(alwaysHide || hideIfNoTabs);
  }


  // calculateType() {
  //   if (this.reflexiveField.foreignSource) {
  //     this.typ
  //   }
  // }

  getSyncFields() {
    return this.model.fields[this.fieldName].reflexiveModelArrayConfig.tabConfig.fieldNamesTabSync;
  }

  hasSyncFields() {
    return this.model.fields[this.fieldName].reflexiveModelArrayConfig
      && this.model.fields[this.fieldName].reflexiveModelArrayConfig.tabConfig
      && !!this.model.fields[this.fieldName].reflexiveModelArrayConfig.tabConfig.fieldNamesTabSync;
  }

  setVisibilityTabSwitchButtons(tabs) {
    if (this.tabFormContainer) {
      const tabContainerWidth = this.tabFormContainer.nativeElement.offsetWidth;
      let sumWidthTab = 0;
      tabs.forEach(tab => {
        sumWidthTab += tab.nativeElement.offsetWidth;
      });
      let addButtonWidth = 50;
      if (this.tabFormAddButtonContainer) {
        addButtonWidth = this.tabFormAddButtonContainer.nativeElement.offsetWidth;
      }
      if ((sumWidthTab + addButtonWidth) >= tabContainerWidth) {
        this.tabSwitchButton = true;
      }
      if ((sumWidthTab + addButtonWidth) <= tabContainerWidth) {
        this.tabSwitchButton = false;
      }
      this.changeDetector.detectChanges();
    }
  }

  ngAfterViewInit() {
    this.setVisibilityTabSwitchButtons(this.tabs);
    this.subscriptions.push(
      this.tabs.changes.subscribe(tabs => {
        this.setVisibilityTabSwitchButtons(tabs);
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.filter(s => !!s).map(s => s.unsubscribe());
    this.geliosFieldService.tabAddedFieldNames.next(null);
    if (this.reflexiveField && this.reflexiveField.onDestroy) {
      this.reflexiveField.onDestroy(this);
    }
  }

  isTextField(): boolean {
    return this.reflexiveField.type === FieldType.StringField;
  }

  isRequired(): boolean {
    if (this.reflexiveField.disableCacheForIsRequired) {
      return this.calculateIsRequired();
    }

    if (this._isRequired === null) {
      this._isRequired = this.calculateIsRequired();
    }

    return this._isRequired;
  }

  calculateIsRequired(): boolean {
    const fakeControl = new FormControl('');
    return (!!this.reflexiveField.validators) && this.reflexiveField.validators.reduce(
      (carry: boolean, validator: ValidatorFn) => carry
        || (
          validator(fakeControl) && validator(fakeControl).required),
      false
    );
  }

  @HostBinding('class.hidden') get isHidden() {
    return this.reflexiveField.type === FieldType.HiddenField;
  }

  onValueChange(event) {
    if (this.reflexiveField.onChange) {
      this.reflexiveField.onChange(event, this.formGroup, this.fieldName);
    }
    this.valueChange.emit(event);
  }

  conjugationOfDay(days) {
    return conjugationOfDay(days, this.translate);
  }

  getTabLabel(i) {
    let labelValue = null;

    if (typeof this.reflexiveField.reflexiveModelArrayConfig.tabConfig.labelToDisplay === 'string') {
      labelValue = this.translate.instant(this.reflexiveField.reflexiveModelArrayConfig.tabConfig.labelToDisplay) + ` ${i + 1}`;
    }

    if (typeof this.reflexiveField.reflexiveModelArrayConfig.tabConfig.labelToDisplay === 'function') {
      labelValue = this.reflexiveField.reflexiveModelArrayConfig.tabConfig.labelToDisplay(
        this.formGroup.controls[this.fieldName]['controls'][i]
      );
    }

    if (this.reflexiveField.reflexiveModelArrayConfig.tabConfig.fieldToDisplay) {
      labelValue = this.formGroup.controls[this.fieldName]['controls']
        [i].value[this.reflexiveField.reflexiveModelArrayConfig.tabConfig.fieldToDisplay];
      if (this.reflexiveField.reflexiveModelArrayConfig.tabConfig.fieldToDisplay === 'period') {
        labelValue = this.conjugationOfDay(labelValue);
      }
    }

    if (labelValue instanceof Function) {
      return this.translate.instant(this.reflexiveField.reflexiveModelArrayConfig.tabConfig.emptyTabLabel);
    }
    if (labelValue === '') {
      return this.translate.instant(this.reflexiveField.reflexiveModelArrayConfig.tabConfig.emptyTabLabel);
    }
    if (labelValue === null) {
      return this.translate.instant(this.reflexiveField.reflexiveModelArrayConfig.tabConfig.emptyTabLabel);
    }

    if (!this.reflexiveField.reflexiveModelArrayConfig.tabConfig.immutableListName) {
      return labelValue;
    }

    return this.immutableList.getItemById(this.reflexiveField.reflexiveModelArrayConfig.tabConfig.immutableListName,
      labelValue);
  }

  tabActive(index) {
    let fields = [this.fieldName];
    if (this.hasSyncFields()) {
      fields = fields.concat(this.getSyncFields());
    }
    this.geliosFieldService.clickedTab.next({index: index, fieldNamesSync: fields});
  }

  addNewChildIsAvailable() {
    const reflexiveModelArrayConfig = this.model.fields[this.fieldName].reflexiveModelArrayConfig;
    if (reflexiveModelArrayConfig.disableAdding || reflexiveModelArrayConfig.tabConfig.buttonAddHidden) {
      return false;
    }
    const maxItemCount = reflexiveModelArrayConfig.maxItemCount;
    if (!maxItemCount) {
      return true;
    }
    const controlCount = (this.formGroup.controls[this.fieldName] as FormArray).length;
    return controlCount < maxItemCount;
  }

  addNewChild() {
    const model = this.model.fields[this.fieldName].reflexiveModelArrayConfig.createChild();
    if (this.model.fields[this.fieldName].value) {
      (this.model.fields[this.fieldName].value as Array<any>).push(model);
    } else {
      this.model.fields[this.fieldName].value = [model];
    }
    const newFormGroup = model.getFormGroup(
      this.formBuilder, this.model.fields[this.fieldName].reflexiveModelArrayConfig.fields
    );
    (this.formGroup.controls[this.fieldName] as FormArray).push(
      newFormGroup
    );
    // model.setFormGroup(newFormGroup);
    if (this.model.fields[this.fieldName].reflexiveModelArrayConfig.onChildAdded) {
      this.model.fields[this.fieldName].reflexiveModelArrayConfig.onChildAdded(
        this.formGroup.controls[this.fieldName] as FormArray,
        newFormGroup
      );
    }
    this.formGroup.controls[this.fieldName].markAsTouched();
    this.formGroup.controls[this.fieldName].updateValueAndValidity();
    if (this.reflexiveField.type === FieldType.ReflexiveModelArrayField
      && this.reflexiveField.reflexiveModelArrayConfig.tabConfig) {
      this.tabActive(this.formGroup.controls[this.fieldName]['controls'].length - 1);
    }
    this.tabAdded.next(true);
  }

  switchToRight() {
    const index = this.tabVisible + 1;
    if (this.formGroup.controls[this.fieldName]['controls'][index] !== undefined) {
      let fields = [this.fieldName];
      if (this.hasSyncFields()) {
        fields = fields.concat(this.getSyncFields());
      }
      this.geliosFieldService.switchRightTabs.next({
        index: index,
        fieldNamesSync: fields
      });
      this.tabActive(index);
    } else {
      this.tabFormContainerItems.nativeElement.scrollLeft = this.tabFormContainerItems.nativeElement.scrollWidth;
    }
  }

  switchToLeft() {
    const index = this.tabVisible - 1;
    if (this.formGroup.controls[this.fieldName]['controls'][index] !== undefined) {
      let fields = [this.fieldName];
      if (this.hasSyncFields()) {
        fields = fields.concat(this.getSyncFields());
      }
      this.geliosFieldService.switchLeftTabs.next({
        index: index,
        fieldNamesSync: fields
      });
      this.tabActive(index);
    }
  }

  removeChild(index) {
    if (this.model.fields[this.fieldName].reflexiveModelArrayConfig.beforeRemoveItem) {
      const result = this.model.fields[this.fieldName].reflexiveModelArrayConfig.beforeRemoveItem();
      if (!result) {
        return;
      }
    }
    const deletedValues = (this.formGroup.controls[this.fieldName] as FormArray).at(index).value;
    (this.formGroup.controls[this.fieldName] as FormArray).removeAt(index);
    (this.model.fields[this.fieldName].value as Array<ReflexiveRestModel>)[index].onDestroy();
    (this.model.fields[this.fieldName].value as Array<ReflexiveRestModel>).splice(index, 1);
    if (this.model.fields[this.fieldName].reflexiveModelArrayConfig.onChildRemoved) {
      this.model.fields[this.fieldName].reflexiveModelArrayConfig.onChildRemoved(
        this.formGroup.controls[this.fieldName] as FormArray,
        deletedValues
      );
    }
    if (this.formGroup.controls[this.fieldName]['controls'].length === 0) {
      this.tabVisible = null;
    } else if (this.tabVisible === index) {
      this.tabActive(this.formGroup.controls[this.fieldName]['controls'].length - 1);
    }
    this.formGroup.controls[this.fieldName].markAsTouched();
    this.formGroup.controls[this.fieldName].updateValueAndValidity();
  }

  showChildField(model: ReflexiveRestModel, fieldName: string, formGroup: FormGroup): boolean {
    return model.fields[fieldName] &&
      (!model.fields[fieldName].isVisible || model.fields[fieldName].isVisible(formGroup));
  }
}
